import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { formatDate } from '../../../utils/format';

const preview = (prompt) => {
  const text = String(prompt || '').replace(/\s+/g, ' ').trim();
  return text.length > 90 ? `${text.slice(0, 90)}…` : text;
};

const TemplateItem = ({ template, selected, onSelect }) => (
  <li>
    <button
      type="button"
      className={`pt-list-item${selected ? ' selected' : ''}`}
      onClick={() => onSelect(template)}
    >
      <strong>{template.name}</strong>
      <span>{preview(template.prompt)}</span>
      {formatDate(template.updated_at, '') && (
        <em>Updated {formatDate(template.updated_at, '')}</em>
      )}
    </button>
  </li>
);

/** Left pane: search box and the saved templates in name order. */
export default function TemplateList({ library }) {
  const { templates, visible, loading, filter, setFilter, selectedId, select } = library;
  return (
    <aside className="prompt-templates-list-pane">
      <div className="pt-input pt-search">
        <MagnifyingGlassIcon />
        <input
          type="search"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Search templates..."
        />
      </div>

      {loading ? (
        <p className="pt-empty">Loading...</p>
      ) : visible.length === 0 ? (
        <p className="pt-empty">
          {templates.length === 0
            ? 'No templates yet. Create the first one.'
            : 'No template matches this search.'}
        </p>
      ) : (
        <ul className="pt-list">
          {visible.map((template) => (
            <TemplateItem key={template.id} template={template} selected={template.id === selectedId} onSelect={select} />
          ))}
        </ul>
      )}
    </aside>
  );
}
